import QueryAndMutationForMembership, {QueryAndMutationForMembershipObject, UpdateMembershipInput} from './QueryMutation';
export {QueryAndMutationForMembershipObject, UpdateMembershipInput};
export default QueryAndMutationForMembership;



// WEBPACK FOOTER //
// ./src/pages/MembershipsPage/components/MembershipDetail/components/QueryMutation/index.ts